import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionTokenData } from "./dimension";

export const BlurType = z.enum(["Layer", "Background"]);

export const BlurValue = z.object({
  type: BlurType,
  radius: DimensionTokenData,
});

export const BlurTokenData = tokenAliasOrValue(BlurValue);

export type BlurType = z.infer<typeof BlurType>;
export type BlurValue = z.infer<typeof BlurValue>;
export type BlurTokenData = z.infer<typeof BlurTokenData>;
